import { useIntl } from "react-intl";

export function BillingUsageMeter({
  label,
  used,
  total,
  unit,
  detail,
  showPercentage = true,
}: {
  label: string;
  used: number;
  total: number;
  unit: string;
  detail?: string | null;
  showPercentage?: boolean;
}) {
  const intl = useIntl();
  const percentage = total > 0 ? Math.min(100, Math.round((used / total) * 100)) : 0;

  return (
    <div className="space-y-3 rounded-2xl border border-border/70 bg-muted/20 p-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-medium text-foreground">{label}</div>
          {showPercentage ? (
            <div className="mt-1 text-xs text-muted-foreground">
              {intl.formatMessage(
                {
                  id: "brandSettings.billing.usageUsedPercent",
                  defaultMessage: "{percentage}% used",
                },
                { percentage },
              )}
            </div>
          ) : null}
        </div>
        <div className="text-right text-sm font-semibold text-foreground">
          {used} / {total}
          <div className="text-xs font-normal text-muted-foreground">{unit}</div>
          {detail ? <div className="text-xs font-semibold text-primary">{detail}</div> : null}
        </div>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-border/70">
        <div className="h-full rounded-full bg-primary" style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}
